var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"min-h-screen bg-white flex flex-col items-center relative bg-purple-primary-900 px-6 py-2"},[_c('h2',{staticClass:"text-xl font-medium text-gray-800 mb-4"},[_vm._v(" "+_vm._s(_vm.$t("privacy_policy.title"))+" ")]),_c('div',{staticClass:"text-gray-500 text-sm",domProps:{"innerHTML":_vm._s(_vm.$t('privacy_policy.content'))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }